import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { theme } from "../theme";

export default function Landing() {
  // /host and /play are separate chunks now. Anyone sitting on this page is
  // about to need one of them, so fetch both while they read — by the time a
  // thumb lands on a button the code is already in cache.
  useEffect(() => {
    const warm = () => {
      void import("./Host");
      void import("./Play");
    };
    const idle = window.requestIdleCallback;
    if (idle) {
      const handle = idle(warm, { timeout: 2000 });
      return () => window.cancelIdleCallback?.(handle);
    }
    const timer = window.setTimeout(warm, 300);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <main className="stage-lit flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <Logo size={40} />
      <h1 className="mt-10 max-w-[16ch] font-display text-[clamp(2.5rem,8vw,5rem)] font-extrabold leading-[0.95]">
        {theme.brand.tagline}
      </h1>
      <p className="mt-5 max-w-[42ch] text-lg text-mute">
        One screen for the room, one phone per player. Questions written fresh for whatever topic you pick.
      </p>

      <div className="mt-10 flex w-full max-w-sm flex-col gap-3">
        <Link
          to="/host"
          className="rounded-[var(--radius-pill)] bg-spot px-8 py-4 text-lg font-semibold text-stage
                     transition-transform active:scale-[0.97]"
        >
          Host on this screen
        </Link>
        <Link
          to="/play"
          className="rounded-[var(--radius-pill)] border border-haze bg-stage-2/70 px-8 py-4 text-lg
                     font-semibold text-chalk transition-transform active:scale-[0.97]"
        >
          Join with a code
        </Link>
      </div>
    </main>
  );
}
